import React, { ReactNode } from "react";

import "./PromotionModal.scss";
import { useCommonUtil } from "../util/useCommonUtil";

interface PromotionModalProps {
    // children?: ReactNode;
    // onClose: () => void;
    // title?: string;
    // content?: string;
    id: number;
    fileId: string;
    price?: number
    callback: (data: number) => void
    onClose: (data: number) => void
}

const PromotionModal: React.FC<PromotionModalProps> = ({
    id, fileId, price = 0, callback, onClose
}) => {
    const { formatNumber } = useCommonUtil();

    return (
        <div className="alert-modal-overlay">
            <div className="promotion-modal-container">
                <div className="modal-header">
                </div>
                <div className="modal-content">
                    <img src={`${process.env.REACT_APP_DOMAIN}/Common/File/Download.do?fileId=${fileId}`} alt="" />
                    <div style={{ fontSize: '2.5em' }}>이용일정 동안 총 금액은 <span style={{ fontWeight: '700', color: '#3E83F1' }}>{formatNumber(price)}</span>원입니다.</div>
                    <div className="promotion-btn-wrap">
                        <div className="p-btn-wrap">
                            <button
                                onClick={() => {
                                    callback(id)
                                }}
                            >
                                신청하기
                            </button>
                            <div style={{ width: '50px' }}></div>
                            <button
                                style={{ background: '#9ba5b1' }}
                                onClick={() => {
                                    onClose(id)
                                }}
                            >
                                신청안함
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromotionModal;
